import reactIcon from '../../images/platforms/react-js-icon.svg';
import reactNative from '../../images/platforms/react-native-app-icon.svg';
import angular from '../../images/platforms/angular-icon.svg';
import nodeJs from '../../images/platforms/node-js-icon.svg';
import wordPress from '../../images/platforms/wordpress-icon.svg';
import tailwindCss from '../../images/platforms/tailwind-css-icon.svg';
import bootStrap from '../../images/platforms/bootstrap-5-logo-icon.svg';
import shopify from '../../images/platforms/shopify-icon.svg';

// Services-Green
import giftGreen from '../../images/services/gift-green.svg';
import expertGreen from '../../images/services/expert-green.svg';
import twofour from '../../images/services/247-green.svg';
import loveDev from '../../images/services/love-dev-green.svg';
import standardGreen from '../../images/services/standard-green.svg';
import wifigreen from  '../../images/services/wiwfi-green.svg';

// Services-White
import giftWhite from '../../images/services/gift-white.svg';
import expertWhite from '../../images/services/expert-white.svg';
import twoFourWhite from '../../images/services/247-white.svg';
import loveDevWhite from '../../images/services/love-dev-white.svg';
import standardWhite from '../../images/services/standard-white.svg';
import wifiWhite from '../../images/services/wifi-white.svg';


// Suqare Blocks
import whatFreq from '../../images/whatsinside/frequent.svg';
import whatConst from '../../images/whatsinside/constrained.svg';
import whatApps from '../../images/whatsinside/apps.svg';
import whatFont from '../../images/whatsinside/fonticon.svg';
import whatDrop from '../../images/whatsinside/drop.svg';
import whatOrgan from '../../images/whatsinside/organized.svg';
import whatVector from '../../images/whatsinside/vector.svg';
import whatAdapt from '../../images/whatsinside/adaptive.svg';

// Avatars Import 

import user1 from '../../images/avatars/male-01.jpg';
import user2 from '../../images/avatars/male-02.jpg';
import user3 from '../../images/avatars/male-03.jpg';
import user4 from '../../images/avatars/male-04.jpg';
import user5 from '../../images/avatars/male-05.jpg';
import user6 from '../../images/avatars/male-06.jpg';
import user7 from '../../images/avatars/male-07.jpg';
import user8 from '../../images/avatars/female-08.jpg';
import user9 from '../../images/avatars/female-03.jpg';
import user10 from '../../images/avatars/female-10.jpg';
import user11 from '../../images/avatars/brian-hughes.jpg';
import user12 from '../../images/avatars/male-08.jpg';
import user13 from '../../images/avatars/male-09.jpg';
import user14 from '../../images/avatars/female-04.jpg';
import user15 from '../../images/avatars/male-10.jpg';


import TimeImage from '../../images/acheivements-icons/time.svg'
import ExperienceImage from '../../images/acheivements-icons/experience.svg'
import projectsHandleImage from '../../images/acheivements-icons/projects.svg'
import clientImages from '../../images/acheivements-icons/clients.svg'



  const accordionCont = [
    {
      title: "Did you built this application on your own",
      desc : "Yes, I developed this application independently. It's the result of my passion for coding and my desire to create a platform that simplifies the learning experience for coding technologies like React and Angular. ",
      panelCount: "panel1"
    },
    {
      title: "What programming languages do you cover on your platform",
      desc: "We cover a wide range of programming languages, including but not limited to React, Angular, JavaScript, HTML, CSS, and more.",
      panelCount: "panel2"
    },    
    {
      title: "Who is this platform for",
      desc: "Our platform is designed for beginners and intermediate-level developers looking to enhance their skills in web development and coding using technologies like React , Angular , Node js , Html and Css.",
      panelCount: "panel3"
    },
    {
      title: "Do I need any prior coding experience to get started",
      desc: "No prior coding experience is required. Our courses are structured to accommodate learners of all levels, from beginners to more experienced developers.",
      panelCount: "panel4"
    },    
    {
      title: "How are the courses structured",
      desc: "Our courses are structured in a modular format, allowing you to learn at your own pace. Each module focuses on specific concepts and technologies, with hands-on exercises to reinforce learning.",
      panelCount: "panel5"
    },
  ]

  const collaborateDate = [
    {
      heading: "Free Forever",
      description: "My Free Course Gives you unique knowledge , just dive into my complete website to know everything that i have learnt. if anything comes to your mind just contact me , feel free to ask doubts at any time."
    },
    {
      heading: "Easy Learning",
      description: "SGcodes has powerful learning techniques , so that you can learn Html and css within a week and usable javascript in a month , with seemless examples you can learn faster than expected and even you can build an application in a month"
    },
    {
      heading: "Fast and Exact",
      description: "Not Only Fast , i can give you best examples to learn , i follow the best code standards so that everyone can understand and try my exmaples to get exact output"
    },
    {
      heading: "Connect With Me",
      description: "You can connect with me at anytime and you can get solved your doubts with me ,  you can find my contact at the bottom of the page , dont worry im here to help "
    }
  ]

  const technologiesData = [
    {
      techImage: reactIcon,
      techName: 'React Js',
      buttonText: 'Learn React',
      techDesc: "I have over 2 years of hands-on experience in React.js, during which I've successfully delivered more than 10 applications. My expertise includes front-end development, where I've implemented responsive and user-friendly interfaces is it good",
      techLink: 'LearnReact',
    },
    {
      techImage: angular,
      techName: 'Angular',
      buttonText: 'Learn Angular',
      techDesc: "With 6 months of hands-on experience in Angular, I've successfully delivered two substantial projects. My expertise lies in front-end development, where I've contributed to building impactful and functional interfaces, showcasing my proficiency in Angular development.",
      techLink: 'LearnAngular',
    },
    {
      techImage: nodeJs,
      techName: 'Node Js',
      buttonText: 'Learn Node',
      techDesc: "In my 6 months of hands-on experience with Node.js, I've successfully delivered three projects focused on CRUD operations. Specializing in backend development, I've demonstrated proficiency in creating robust and efficient systems for data management and manipulation using Node.js."
    },
    {
      techImage: reactNative,
      techName: 'React Native',
      buttonText: 'Learn React Native',
      techDesc: "With 1 year of experience in React Native, I've successfully delivered two mobile applications. My expertise lies in mobile app development, showcasing proficiency in creating cross-platform solutions and ensuring a seamless user experience."
    },
    {
      techImage: tailwindCss,
      techName: 'Tailwind Css',
      buttonText: 'Learn Tailwind',
      techDesc: "With 2 years of experience in Tailwind CSS, I've successfully delivered over 5 projects. My expertise lies in crafting efficient and visually appealing styles, leveraging the power of Tailwind CSS to streamline the design and development process."
    },
    {
      techImage: bootStrap,
      techName: 'Bootstrap',
      buttonText: 'Learn Bootstrap',
      techDesc: "With 2 years of experience in Bootstrap, During this time, I've applied Bootstrap's responsive framework to design and develop user-friendly interfaces, contributing to the success of various projects."
    },
    {
      techImage: wordPress,
      techName: 'Wordpress',
      buttonText: 'Learn Wordpress',
      techDesc: "With 1 year of experience in WordPress design, My expertise includes leveraging WordPress themes, customization, and implementing design best practices to deliver engaging and user-friendly online experiences."
    },
    {
      techImage: shopify,
      techName: 'Shopify',
      buttonText: 'Learn Shopify',
      techDesc: "With 1 year of experience in Shopify design, I've honed my skills in creating visually compelling and user-friendly e-commerce interfaces. My expertise includes customizing Shopify themes and optimizing the overall shopping experience."
    },

    
  ]

  const whySgServices = [
    {
      imager: expertGreen,
      secondaryImage: expertWhite ,
      title: 'My Expertise at you service',
      desc: '3 years delivering top-quality Designs and Web applications. Worked with a dedicated team. Improvise and learn with my website to build your own application'
    },
    {
      imager: twofour,
      secondaryImage: twoFourWhite ,
      title: 'Support for you at any time',
      desc: "I can assist and support you with everything i've got , you can call me on mobile or mail me any time , you can give me feedback or you can ask me doubts"
    },
    {
      imager: giftGreen,
      secondaryImage: giftWhite ,
      title: 'No Premium or Pricing Needed',
      desc: 'You can discover countless examples and open documentation without any pricing or premium . Everything is free , just dive into learning'
    },
    {
      imager: loveDev,
      secondaryImage: loveDevWhite ,
      title: 'For Developers With Love',
      desc: 'My Examples and solutions are fast and easy to integrate with clear and simple documentation , in Which every single line is made with my own knowledge with love for learners '
    },
    {
      imager: standardGreen,
      secondaryImage: standardWhite ,
      title: 'Built With Standards In Mind',
      desc: 'This Complete Application is buit with react and tailwind css, Set the complete code with standards and everything is designed with wireframe'
    },
    {
      imager: wifigreen,
      secondaryImage: wifiWhite ,
      title: 'Sharing & Connectivity ',
      desc: 'With my Syntax Editor you can just easily share or copy the complete code with just copy button and you can even share your ideas to improve my website'
    }
  ]

  const getStartedImages = [
    {
      image: reactIcon
    },
    {
      image: reactNative
    },
    {
      image: nodeJs
    },
    {
      image: angular
    },
    {
      image: wordPress
    },
    {
      image: shopify
    },
    {
      image: tailwindCss
    },
    {
      image: bootStrap
    }
    

  ]

  const testimonials = [
    {
      title: 'Amy Caroline',
      rating: 5,
      image: require('../../images/avatars/female-03.jpg'),
      desc: 'This platform is a game-changer! I went from knowing nothing about coding to building responsive websites with HTML, CSS, and Bootstrap in just a few weeks. The hands-on approach and interactive lessons make learning enjoyable and effective.'
    },
    {
      title: 'Elizabeth Olsen',
      rating: 4,
      image: require('../../images/avatars/female-02.jpg'),
      desc: "I've tried several coding platforms, but this one stands out. The React and React Native courses are comprehensive, with clear explanations and practical exercises. I can confidently say that I am now a proficient React developer, thanks to this fantastic resource."
    },
    {
      title: 'Catherine',
      rating: 3,
      image: require('../../images/avatars/female-01.jpg'),
      desc: 'Learning Angular seemed like a daunting task, but this website made it a breeze. The step-by-step tutorials and real-world projects helped me grasp the concepts quickly. I can now confidently build robust web applications using Angular.'
    },
    {
      title: 'Jhon Doe',
      rating: 4,
      image: require('../../images/avatars/male-01.jpg'),
      desc: "Node.js was always on my to-learn list, and this platform made the process incredibly smooth. The Node.js course is well-structured, and the interactive coding challenges solidified my understanding. I'm now confidently working with server-side JavaScript."
    },
    {
      title: 'Brad Jhon',
      rating: 5,
      image: require('../../images/avatars/male-02.jpg'),
      desc: 'Tailwind CSS has revolutionized my approach to styling. The concise lessons on this website helped me understand the utility-first approach and how to create beautiful, responsive designs efficiently. Tailwind is now my go-to CSS framework!'
    },
    {
      title: 'Gomez',
      rating: 4,
      image: require('../../images/avatars/female-04.jpg'),
      desc: "Bootstrap has been a staple in web development, and this website's Bootstrap course does justice to its power. The lessons are clear, concise, and the hands-on projects allow you to apply what you've learned immediately. Highly recommended!"
    },
    {
      title: 'Jennifer Lawrence',
      rating: 4,
      image: require('../../images/avatars/female-05.jpg'),
      desc: 'Learning Angular seemed like a daunting task, but this website made it a breeze. The step-by-step tutorials and real-world projects helped me grasp the concepts quickly. I can now confidently build robust web applications using Angular.'
    },
    {
      title: 'Fernandez',
      rating: 3,
      image: require('../../images/avatars/female-06.jpg'),
      desc: "I've always wanted to dive into mobile app development, and React Native was the perfect starting point. The practical exercises and real-world projects in the React Native course equipped me with the skills to build cross-platform mobile applications."
    },
    {
      title: 'Charolette',
      rating: 4,
      image: require('../../images/avatars/female-07.jpg'),
      desc: "As a beginner, I appreciate the beginner-friendly approach of this website. The explanations are clear, and the gradual progression from basics to advanced concepts allowed me to build a strong foundation in coding."
    },
    {
      title: "Kelly",
      rating: 5,
      image: require('../../images/avatars/female-08.jpg'),
      desc: "Angular was a tough nut to crack, but the structured lessons and hands-on projects on this platform made it a smooth learning experience. Now, I can build dynamic and interactive web applications with ease."
    },
    {
      title: 'Eva Jane',
      rating: 4,
      image: require('../../images/avatars/female-09.jpg'),
      desc: 'Learning to code can be overwhelming, but the React course here breaks down complex concepts into digestible parts. The practical examples and projects helped reinforce my understanding, making React development enjoyable.'
    },
    {
      title: 'Thomas J',
      rating: 5,
      image: require('../../images/avatars/male-03.jpg'),
      desc: 'Node.js and server-side scripting were a mystery to me until I took the course on this platform. The real-world applications and exercises provided the hands-on experience I needed to confidently tackle backend development projects.'
    },
    // {
    //   title: 'Stella',
    //   image: require('../../'),
    //   desc: "Tailwind CSS was a breath of fresh air in the world of styling. The concise utility-first approach taught on this website allowed me to streamline my workflow and create modern and sleek designs effortlessly."
    // },
    // {
    //   title: "Jane Foster",
    //   image: require('../../'),
    //   desc: "Bootstrap has been a lifesaver for prototyping and building responsive websites. The Bootstrap course here not only taught me the basics but also advanced techniques to make my projects stand out."
    // },
    // {
    //   title: 'Ashley ',
    //   image: require('../../'),
    //   desc: 'I was intimidated by the world of frontend development, but the HTML and CSS courses here made it so approachable. I can now confidently create visually stunning and responsive web pages'
    // },
    // {
    //   title: 'Connie S. Hahn',
    //   image: require('../../'),
    //   desc: "The diversity of courses on this platform is impressive. From frontend with React to backend with Node.js, I've gained a well-rounded skill set that has opened up numerous opportunities for me in the tech industry"
    // }
  ]

  const whatsInside = [
    {
      image: whatFreq,
      count: '30+',
      desc: 'Frequent and reusable templates all screens'
    },
    {
      image: whatConst,
      count: '250+',
      desc: 'Constrained components & well-crafted UI widgets'
    },
    {
      image: whatApps,
      count: '6+',
      desc: 'Languages can be learned and used to build apps '
    },
    {
      image: whatFont,
      count: 'Fonts',
      desc: 'Powered by free Manrope and Rubik fonts'
    },
    {
      image: whatDrop,
      count: 'Styles',
      desc: 'Made and build completely with Tailwind css '
    },
    {
      image: whatOrgan,
      count: 'Orgnaized',
      desc: 'Organized and labeled for a faster workflow'
    },
    {
      image: whatVector,
      count: '100%',
      desc: '100% Component based Application made with React'
    },
    {
      image: whatAdapt,
      count: 'Adaptive',
      desc: 'Prepared components for mobile, tablet & desktop'
    },
  ]

  const usersChat = [
    {
      image: user1,
      lastSeen: 'Online',
      email: "sgRome@Hmail.com",
      username: "Ganesh",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user2,
      lastSeen: 'Last Seen 4h ago',
      email: "Dove@gamil.com",
      username: "John Doe",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user3,
      lastSeen: 'Online',
      email: "Statham01@gmail.com",
      username: "Jason Statham",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user4,
      lastSeen: 'Last Seen 2h ago',
      email: "swatch@gmail.com",
      username: "Arnold",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user5,
      lastSeen: 'Online',
      email: "Spidey@Hmail.com",
      username: "Andrew Garfeild",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },    {
      image: user6,
      lastSeen: 'Last Seen 1h ago',
      email: "Peter@Hmail.com",
      username: "Tobey Maguire",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user7,
      lastSeen: 'Online',
      email: "Parker@Hmail.com",
      username: "Tom Holland",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user8,
      lastSeen: 'Online',
      email: "Wednesday@Netflix.com",
      username: "Jenna Ortega",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user9,
      lastSeen: 'Online',
      email: "Millie@stranger.com",
      username: "Millie Bobby",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user10,
      lastSeen: 'Online',
      email: "taylorSwift@Singer.com",
      username: "Taylor Swift",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user11,
      lastSeen: 'Last Seen 6h ago',
      email: "will@pirsuit.com",
      username: "Will Smith",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user12,
      lastSeen: 'Online',
      email: "tom@impossible.com",
      username: "Tom Cruise",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user13,
      lastSeen: 'Online',
      email: "henry@superMan.com",
      username: "Henry Cavilli",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user14,
      lastSeen: 'Online',
      email: "charlize@beauty.com",
      username: "Charlize",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    },
    {
      image: user15,
      lastSeen: 'Online',
      email: "robert@iron.com",
      username: "Robert",
      userId: "#Ea253260Ed",
      joinedAt: "03-02-2022",
      messages: [],
    }
  ]


  const AcheivedBlock = [
    {
      count: 40,
      title: 'Projects',
      image: projectsHandleImage,
      duration: 3,
    },
    {
      count: 25 ,
      title: 'Happy Clients',
      image: clientImages ,
      duration: 4,
    },
    {
      count: 3 ,
      title: 'Experience',
      image: ExperienceImage,
      duration: 5,
    },
    {
      count: 600,
      title: 'Hours Spent',
      image: TimeImage,
      duration: 3,
    },
  ]

  const learnLanguagesCards = [
    {
      topImage: reactIcon,
      title: 'React',
      link: 'LearnReact'
    },
    {
      topImage: angular,
      title: 'Angular',
      link: 'LearnAngular'
    },
    {
      topImage: bootStrap,
      title: 'Bootstrap',
      link: 'LearnBootstrap'
    },
    {
      topImage: tailwindCss,
      title: 'Tailwind',
      link: 'LearnTailwind'
    },
    {
      topImage: reactNative,
      title: 'ReactNative',
      link: 'LearnRaect'
    },
    {
      topImage: wordPress,
      title: 'Wordpress',
      link: 'LearnAngular'
    },
    {
      topImage: nodeJs,
      title: 'Node Js',
      link: 'LearnAngular'
    },
    {
      topImage: shopify,
      title: 'Shopify',
      link: 'LearnTailwind'
    },
  ]

  export const Content = {
    testimonials , 
    getStartedImages , 
    whySgServices , 
    technologiesData , 
    collaborateDate , 
    accordionCont , 
    whatsInside,
    usersChat,
    AcheivedBlock,
    learnLanguagesCards
  }

